export class LoadFileModel {  
  fileB64: string;
  fileName: string;
  fileCategory: number;
  idUser: number;
  fileType: string;
  BlobPath: string;
  container: string;

  constructor() {
    this.fileB64 = "";
    this.fileName = "";
    this.fileCategory = 0;
    this.idUser = 0;
  }

}
